<template>
  <div class="file-card" @click="previewFn">
		<svg-icon cls="type-icon" :icon="iconImg" />
    <div class="right-content">
      <div class="flex-column">
        <span class="file-rename-name ellipsis" :title="cardData.name">{{isSearch ? cardData.showName : cardData.name}}</span>
        <div class="other">
          <i class="iconfont icon-library_read" />
          <span>{{cardData.read_num}}</span>
          <div class="line"></div>
          <span class="name ellipsis">{{cardData.creator && cardData.creator.user_name}}</span>
          <span class="margin-left-8">{{updateTime}}</span>
        </div>
        <div class="tags" v-show="cardData.tags && cardData.tags.length">
          <template v-for="(item) in cardData.tags">
            <span class="tag-item" v-for="(tag, key) in item.contents" :key="key">{{tag.content}}</span>
          </template>
        </div>
      </div>
      <i class="iconfont icon-a-dibuicon28px" @click="showMenu" />
    </div>
  </div>
</template>
<script>
import dataHandler from '../dataHandler'
import SvgIcon from '../../utils/SvgIcon'
import { formatDate, toast } from '@/utils/common'
import { CommonMixin } from './commonMixin'
export default {
  name: 'FileCard',
  props: {
    cardData: {
      type: Object,
      default: () => ({})
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    permissionsData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SvgIcon
  },
  data () {
    return {
      newCardData: {}
    }
  },
  mixins: [CommonMixin],
  computed: {
    iconImg () {
      return dataHandler.getIcon(this.cardData.extension || (this.cardData.isFolder || this.cardData.type === 'folder' ? 'folder' : 'default'))
    },
    updateTime () {
      return formatDate(this.cardData.updated * 1000, '%YY-%MM-%DD')
    }
  },
  mounted () {

  },
  methods: {
    previewFn () {
      let has_permission = false
      this.permissionsData.permissions && this.permissionsData.permissions.forEach(item => {
        if (item.id === 'preview' && item.value) {
          has_permission = true
        }
      })
      if (this.permissionsData.is_admin || (has_permission || this.cardData.has_permission)) {
        this.appFn({
          action: 'route',
          data: `${window.location.origin}/h5/doclib/files/${this.cardData.library_id}/preview?library_id=${this.cardData.library_id}&book_id=${this.cardData.id || this.cardData.item_id}${this.cardData.file_version ? '&file_version=' + this.cardData.file_version : ''}`
        }, () => {
          this.$router.push({
            path: `/doclib/files/${this.cardData.library_id}/preview`,
            query: {
              library_id: this.cardData.library_id,
              book_id: this.cardData.id || this.cardData.item_id,
              file_version: this.cardData.file_version
            }
          })
        })
      } else {
        toast(`没有${this.cardData.name}的文件预览权限,请发起借阅通过后预览`)
      }
    },
    showMenu (e) {
      e.stopPropagation()
      this.$emit('show-menu', this.cardData)
    }
  }
}
</script>
<style lang="postcss" scoped>
.file-card {
  display: flex;
	width: 100%;
  padding-left: 14px;
  box-sizing: border-box;
  align-items: center;

  & .margin-left-8 {
    margin-left: 8px;
  }

  & .type-icon {
    width: 30px;
    height: 30px;
    border-radius: 4px;
  }

  & .right-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 30px);
    padding: 20px 20px 20px 0;
    box-sizing: border-box;
    position: relative;

    & .flex-column {
      width: calc(100% - 60px);
      display: flex;
      flex-direction: column;
      margin-left: 16px;

      & .file-rename-name {
        width: 100%;
        color: #1B2532;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }

      & .other {
        display: flex;
        align-items: center;
        height: 16px;
        margin-top: 2px;

        & span {
          height: 16px;
          color: #676E87;
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          margin-left: 4px;
        }

        & .line {
          display: flex;
          width: 1px;
          height: 10px;
          background: #D8E0E8;
          margin: 0 12px;
        }

        & .name {
          width: 40%;
        }
      }
    }

    & .icon-a-dibuicon28px {
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;
    }

    & .icon-library_read {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }

    & .tags {
      & .tag-item {
        display: inline-flex;
        align-items: center;
        height: 20px;
        padding: 0 8px;
        align-items: center;
        border-radius: 4px;
        background: #EBF4FF;
        color: #0050A1;
        font-family: "PingFang SC";
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        box-sizing: border-box;
        margin-right: 8px;
        margin-top: 4px;
      }
    }

    &:after {
      content: '';
      display: flex;
      width: 200%;
      height: 1px;
      background: #EBF0F5;
      transform: scale(0.5);
      transform-origin: bottom right;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
